import React from 'react';

import { createIcon } from '../createIcon';

function SvgLocation(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M6.004 0A4.32 4.32 0 001.69 4.314c0 2.57 2.724 6.114 3.84 7.464a.612.612 0 00.943 0c1.121-1.35 3.846-4.894 3.846-7.464A4.32 4.32 0 006.004 0zm-.001 5.625c.841 0 1.5-.652 1.5-1.5s-.659-1.5-1.5-1.5c-.842 0-1.5.652-1.5 1.5s.658 1.5 1.5 1.5z"
          id="Location__svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <g transform="translate(2 2)">
          <path d="M0 0h12v12H0z" />
          <use fill="currentColor" xlinkHref="#Location__svg__a" />
        </g>
      </g>
    </svg>
  );
}

export const LocationFilledIcon = createIcon(SvgLocation, 'LocationFilledIcon');
